module.exports = __webpack_public_path__ + "static/media/opencertslogo.aaab2032.svg";